import $ from 'jquery';

class EditionEditor {
	
	constructor() {

		let editionID = $("#editionID").data("id");

		$("#editDate .btn-primary").click(function(e) {
	        e.preventDefault();
	        $.ajax({
	            data:{
	            	op:"setEditionDate",
	            	id:editionID,
	            	date:$("#eventdate").val(),
	            	location:$("#location").val(),
	            	tentative:$("#tentative").prop('checked') ? 1 : 0
	            }
	        });
	    });


	}


}

export default EditionEditor;

